export const SN_ORDER = 'order'
export const ORDER_PURCHASEORDERS_UPDATED = SN_ORDER + '/PURCHASEORDERS_UPDATED'
export const ORDER_FILE_NAME_UPDATED = SN_ORDER + '/FILE_NAME_UPDATED'